import { render, staticRenderFns } from "./PausedWrapper.vue?vue&type=template&id=05c07493&scoped=true&"
import script from "./PausedWrapper.vue?vue&type=script&lang=js&"
export * from "./PausedWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PausedWrapper.vue?vue&type=style&index=0&id=05c07493&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c07493",
  null
  
)

export default component.exports